export enum ReducersName {
    authentication = 'authentication',
    user = 'user',
    appConfig = 'appConfig',
    clients = 'clients',
    movements = 'movements',
    supplier = 'supplier',
}
